import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SocioFondeadorService } from '../../../../services/socio-fondeador.service';
import { HelpersService } from '../../../../services/tools/helpers.service';

@Component({
  selector: 'app-rechazar-retiro-modal',
  templateUrl: './rechazar-retiro-modal.component.html',
  styleUrls: ['./rechazar-retiro-modal.component.scss']
})
export class RechazarRetiroModalComponent implements OnInit {

  public errors: any = {};
  
  constructor(
    private helperService: HelpersService,
    public socioFondeadorService: SocioFondeadorService,
    public dialogRef: MatDialogRef<RechazarRetiroModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log("ID Retiro: ", this.data.idRetiro);
  }

  public cerrar(){
    this.dialogRef.close({rechazar:false});
  }

  public aceptar(){
    if (!this.data.ingreso){
      this.socioFondeadorService.rechazarIngresoSaldo(this.data.idRetiro)
        .subscribe(response => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.helperService.notification('Ingreso rechazado', 'Se ha rechazado el ingreso de saldo', 'success');
            //Poner dentro del success response
            this.dialogRef.close({rechazar:true});
          }
        }, error => {
          if(error.status == 400) {
            this.showServicesErrors(error.json().content);
          }else{
            this.dialogRef.close({rechazar:false});
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          
          // se resuelven los errores 403 y 500
          this.helperService.httpGlobalError(error, false);
        });

    }else{
      this.socioFondeadorService.rechazarRetiroSaldo(this.data.idRetiro)
        .subscribe(response => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.helperService.notification('Retiro rechazado', 'Se ha rechazado el retiro de saldo', 'success');
            //Poner dentro del success response
            this.dialogRef.close({rechazar:true});
          }
        }, error => {
          if(error.status == 400) {
            this.showServicesErrors(error.json().content);
          }else{
            this.dialogRef.close({rechazar:false});
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          
          // se resuelven los errores 403 y 500
          this.helperService.httpGlobalError(error, false);
        });
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/rechazar-retiro-modal/rechazar-retiro-modal.component.ts